var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apiKeySuccess" },
    [
      _vm.$route.query.isApp != 1
        ? _c("van-nav-bar", {
            attrs: { "left-arrow": "" },
            on: { "click-left": _vm.goCreatedApi }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "commont_body" }, [
        _c("div", { staticClass: "body-title" }, [
          _c("img", {
            attrs: { src: require("@/assets/images/apikey/Frame.svg"), alt: "" }
          }),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("9100167")) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-content" }, [
          _c("div", { staticClass: "body-content-item" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("9100128")))]),
            _vm._v(" "),
            _c("span", { staticClass: "left" }, [
              _vm._v(_vm._s(_vm.pageData.note))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-content-item" }, [
            _c("span", [_vm._v("Access Key")]),
            _vm._v(" "),
            _c("div", { staticClass: "code" }, [
              _c("span", [_vm._v(_vm._s(_vm.pageData.accessKey.slice(0, 24)))]),
              _vm._v(" "),
              _c("i", {
                staticClass: "copy iconfont icon-fuzhi",
                class: [_vm.isDirection ? "mirrorRotateLevel" : ""],
                attrs: { "data-clipboard-text": _vm.pageData.accessKey },
                on: { click: _vm.handleCopy }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-content-item" }, [
            _c("span", [_vm._v("Secret Key")]),
            _vm._v(" "),
            _c("div", { staticClass: "code" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.pageData.accessSecret.slice(0, 24)))
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "copy iconfont icon-fuzhi",
                class: [_vm.isDirection ? "mirrorRotateLevel" : ""],
                attrs: { "data-clipboard-text": _vm.pageData.accessSecret },
                on: { click: _vm.handleCopy }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-content-item" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("9100157")))]),
            _vm._v(" "),
            _c("span", { staticClass: "left" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.pageData.freeSpotState == 0
                      ? _vm.$t("9100131")
                      : _vm.$t("9100131") + "、" + _vm.$t("9100132")
                  ) +
                  "\n                "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "body-content-itemC" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("9100143")))]),
            _vm._v(" "),
            _c("span", { staticClass: "content" }, [
              _vm._v(
                _vm._s(_vm.pageData.whiteList ? _vm.pageData.whiteList : "--")
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-line" }),
          _vm._v(" "),
          _c("div", { staticClass: "message" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("9100168")))
            ]),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "#D9A31A" } }, [
              _vm._v("· " + _vm._s(_vm.$t("9100158")))
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("· " + _vm._s(_vm.$t("9100147")))]),
            _vm._v(" "),
            _c("span", [_vm._v("· " + _vm._s(_vm.$t("9100160")))])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59584455", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59584455","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/apiKey/apiKeySuccess.vue
// module id = 0gcH
// module chunks = 0